import {Vector3} from 'three';
import {SnapCandidate} from 'components/customer/RoomPlanner/helpers/snapping/types';

// A candidate scored by its distance to the drag target, the way the product
// rules' positions are compared.
export const toCandidate = (
    position: Vector3 | null,
    targetPos: Vector3
): SnapCandidate | null =>
    position === null
        ? null
        : {position, distance: position.distanceTo(targetPos)};
